import { render } from "./ExperimentCard.vue?vue&type=template&id=cb2d154e&scoped=true"
import script from "./ExperimentCard.vue?vue&type=script&lang=js"
export * from "./ExperimentCard.vue?vue&type=script&lang=js"

import "./ExperimentCard.vue?vue&type=style&index=0&id=cb2d154e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2d154e"]])

export default __exports__